module.exports = __webpack_public_path__ + "images/icon_globe_state_blue.svg";